/**
 * A patient's name with their owner's after it in muted styling — "Fluffy – John
 * Smith" — so staff who don't recognise a patient by first name can identify the visit
 * by household (WEB-3205).
 *
 * `clientName` is the full free-text owner string: the backend has no first/last split
 * and PIMS names like "Wilson family" aren't reliably splittable. Absent, the patient
 * name renders alone. The patient part inherits surrounding text styles;
 * `clientClassName` replaces the muted default on non-default palettes.
 */
export const PatientClientName = ({
  patientName,
  clientName,
  clientClassName = "font-normal text-annotation",
}: {
  patientName: string;
  clientName?: string | null;
  clientClassName?: string;
}) => (
  <>
    {patientName}
    {clientName && <span className={clientClassName}> – {clientName}</span>}
  </>
);
